{
    "coordinates": [
        41.844528309653526,
        -110.74357070627038
    ],
    "tooltip": "Green River",
    "title": "Green River Formation (Fossil Lake Member)",
    "country": "United States",
    "period": "Paleogene",
    "alt": "TODO"
}
